import {
  Children,
  ComponentType,
  FunctionComponent,
  ReactElement,
  ReactNode,
  cloneElement,
  isValidElement,
} from 'react';

interface Props {
  condition?: boolean;
  children?: ReactNode;
}

export const isElementTypeOf = <T extends ComponentType>(
  target: unknown,
  element: T,
): boolean =>
  isValidElement(target) && (target as ReactElement).type === element;

const Else: FunctionComponent<Omit<Props, 'condition'>> = ({
  children,
}): ReactElement => <>{children}</>;

const If: FunctionComponent<Props> & {
  Else: typeof Else;
} = (props): ReactElement | null => {
  const { condition, children } = props;

  if (condition) {
    return (
      <>
        {Children.toArray(children).filter(
          (child) => !isElementTypeOf(child, Else),
        )}
      </>
    );
  }

  return Children.map(children, (child) => {
    if (isElementTypeOf(child, Else)) {
      return cloneElement(child as ReactElement);
    }

    return null;
  }) as unknown as ReactElement | null;
};

If.Else = Else;

export default If;
